import settings from '@tenant/settings'

/**
 * Helper function to get the icon for the current documentation from the tenant settings.
 *
 * @param {Object} p
 * @param {string} p.nodeType type of documentation
 * @param {string} p.name     name of the icon
 * @returns {*|null}
 */
export const getDocumentationIcon = ({ nodeType, name }) => {
  const availableIcons = settings?.documentationTreeNodeIcons
  if (!nodeType || !name || !availableIcons?.length) return null

  const targetIcon = availableIcons.find(icon => icon.name === name && icon.nodeType === nodeType)

  return targetIcon?.icon || null
}
